import React from 'react'

function ErrorPopup() {
  return (
    <div className='popup'>
      <div className="popup-content">
        <h2>Entschuldigung, das hat leider nicht geklappt!</h2>
        <p>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>
        <button onClick={() => window.location.reload()} type='button'>OK</button>
      </div>
    </div>
  )
}

export default ErrorPopup